<template>
    <v-form ref="form">
        <v-text-field
            prepend-inner-icon="mdi-poll"
            :label="$t('delivery.surveys.labels.name')"
            v-model="form.name"
            :rules="required"
        ></v-text-field>
        <v-text-field
            prepend-inner-icon="mdi-poll"
            :label="$t('delivery.surveys.labels.description')"
            v-model="form.description"
        ></v-text-field>
        <v-card>
            <v-card-title>
                {{ $t('delivery.surveys.labels.questions') }}
            </v-card-title>
            <v-card-text>
                <form-list
                    :new-item="{question: '', options: []}"
                    v-model="form.questions"
                >
                    <template v-slot:default="questionProps">
                        <v-text-field
                            :label="$t('delivery.surveys.labels.question')"
                            v-model="questionProps.item.question"
                            :rules="required"
                        ></v-text-field>
                        <v-card elevation="0">
                            <v-card-title>
                                {{ $t('delivery.surveys.labels.options') }}
                            </v-card-title>
                            <v-card-text>
                                <form-list
                                    :new-item="{value: ''}"
                                    v-model="questionProps.item.options"
                                >
                                    <template v-slot:default="optionProps">
                                        <v-text-field
                                            :label="$t('delivery.surveys.labels.optionValue')"
                                            v-model="optionProps.item.value"
                                            :rules="required"
                                        ></v-text-field>
                                    </template>
                                </form-list>
                                <div class="v-text-field__details mt-4" v-if="questionProps.item.options.length < 2">
                                    <div class="v-messages theme--light error--text" role="alert">
                                        <div class="v-messages__wrapper">
                                            <div class="v-messages__message">
                                                {{ $t('delivery.surveys.rules.options') }}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </v-card-text>
                        </v-card>
                    </template>
                </form-list>
                <div class="v-text-field__details mt-4" v-if="!form.questions.length">
                    <div class="v-messages theme--light error--text" role="alert">
                        <div class="v-messages__wrapper">
                            <div class="v-messages__message">
                                {{ $t('delivery.surveys.rules.questions') }}
                            </div>
                        </div>
                    </div>
                </div>
            </v-card-text>
        </v-card>
    </v-form>
</template>

<script>
    import { FormList, InputErrorsByProps, RequiredRule } from '@dracul/common-frontend'

    export default {
        name: "SurveysForm",
        components: { FormList },
        mixins: [InputErrorsByProps, RequiredRule],
        props: {
            value: {
                type: Object,
                required: true
            }
        },
        computed: {
            form: {
                get() {
                    return this.value
                },
                set(val) {
                    this.$emit('input', val)
                }
            }
        },
        methods: {
            validate() {
                return this.$refs.form.validate()
            }
        }
    }
</script>